// extracted by mini-css-extract-plugin
export default {"main":"BackgroundButtons_main__xdUoP","idea":"BackgroundButtons_idea__xO3oa","ybl":"BackgroundButtons_ybl__d9ttc","fintech":"BackgroundButtons_fintech__7nCU-"};